import React from 'react';
import { useTheme } from '../theme';
import { Faq } from '../lib/schema';

// Renders an FAQ list. Uses native <details>/<summary> so the answers are
// present in the prerendered HTML (good for SEO) and expandable without JS.
export default function FaqSection({ title, faqs }: { title: string; faqs: Faq[] }) {
  const { darkMode, themeClasses } = useTheme();

  return (
    <section className={`${themeClasses.infoCard} rounded-2xl p-5 sm:p-8 border`}>
      <h2 className={`text-2xl font-bold ${themeClasses.textPrimary} mb-6`}>{title}</h2>
      <div className="space-y-3">
        {faqs.map((faq, i) => (
          <details
            key={i}
            className={`group rounded-xl border ${darkMode ? 'bg-slate-950/40 border-slate-800' : 'bg-slate-50 border-slate-100'} p-4`}
          >
            <summary className={`cursor-pointer font-medium ${themeClasses.textPrimary} list-none flex justify-between items-center gap-3`}>
              {faq.q}
              <span className={`${themeClasses.textMuted} transition-transform group-open:rotate-45`}>+</span>
            </summary>
            <p className={`mt-3 ${themeClasses.textSecondary} leading-relaxed`}>{faq.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
